const texts = {
    firstMilestone: {
        title: "Dove tutto è iniziato",
        date: "Ottobre 2014",
        content: `Ci siamo conosciuti il primo giorno di università a Enna, emozionati e pronti per iniziare il nostro percorso in Ingegneria Informatica.
Da quel momento non ci siamo più separati. Abbiamo condiviso sogni, sfide e risate, sostenendoci a ogni passo. \n Il 10 marzo 2015 ci siamo fidanzati e, dopo tre anni di avventure, ci siamo laureati insieme lo stesso giorno festeggiando non solo un traguardo ma il punto di partenza del nostro viaggio professionale insieme.`
    },
    transfers: {
        title: "I primi passi",
        date: "Maggio 2018",
        content: `Dopo la laurea, abbiamo fatto il nostro primo grande passo insieme: il trasferimento a Roma, la città dove abbiamo iniziato a costruire la nostra carriera professionale. Da quel momento, ogni nuova destinazione è stata una nuova sfida, ma soprattutto un'opportunità per crescere insieme.
Tra cambi di città, nuove esperienze e progetti, ci siamo trovati a vivere in diverse città: Roma, Bologna e adesso Milano. Ogni trasferimento ci ha offerto un capitolo diverso nella nostra storia, ma una cosa è sempre rimasta invariata: non ci siamo mai separati.`
    },
    proposal: {
        title: "La proposta",
        date: "Luglio 2022",
        content: `La nostra storia è iniziata durante una serata tra amici. Tra tutte le cose di cui abbiamo parlato, una in particolare ci ha uniti: i Coldplay. La loro musica è stata il nostro primo punto in comune, un legame che ci ha avvicinato e ha segnato l'inizio di qualcosa di speciale.
Sette anni dopo, durante il concerto dei Coldplay a Berlino, quel legame ha preso una nuova forma. Circondati dalla magia della canzone Fix You, il nostro primo punto in comune è diventata la colonna sonora perfetta per una promessa che durerà per sempre.`
    },
    church: {
        name: "La Cerimonia",
        hour: "15:00",
        content: `Celebreremo il nostro amore nel Santuario di Maria Santissima di Custonaci, trasformandolo in un impegno per la vita.`,
        address: "Chiesa Santa Maria di Custonaci\nCustonaci, TP"
    },    
    place: {
        name: "L'accoglienza",
        hour: "19:00",
        content: `Dopo il sì, condivideremo la nostra gioia tra brindisi e tanta allegria al Baglio Santa Lucia.`,
        address: "Baglio Santa Lucia\nAlcamo, TP"
    },    
    giappone: {
        content: `Un Paese dove tradizione e modernità si incontrano in un'atmosfera unica. Da Tokyo a Kyoto, dal maestoso Monte Fuji a tanto altro ancora... Vivremo un viaggio tra templi antichi, città futuristiche, panorami mozzafiato e sapori autentici che ci conquisteranno.`
    },    
    thailandia:{
        content:`Esploreremo il fascino di Bangkok, immergendoci nella sua energia vibrante tra mercati galleggianti, street food e meraviglie architettoniche. Proseguiremo verso il nord della Thailandia, dove tra templi dorati, paesaggi mozzafiato e antiche tradizioni, vivremo un'esperienza autentica e suggestiva. Infine, ci sposteremo a sud, dove ci attendono spiagge paradisiache e acque cristalline, il luogo perfetto per rilassarsi e assaporare la bellezza tropicale.`
    },
    honeymoon:{
        title: "Viaggio di Nozze",
        content: `Un'avventura che abbiamo organizzato con cura, scegliendo ogni dettaglio per rendere questo viaggio davvero speciale.`
    },
    gift:{
        content: `Il vostro affetto e la vostra presenza saranno il dono più grande in questo giorno speciale. Ogni vostro pensiero ci accompagnerà nei ricordi che creeremo durante il nostro viaggio, rendendo ancora più preziosa questa nuova avventura insieme.`
    }
};

export default texts;
